import type {JSONValue} from 'types';
import {getOffset} from 'services/utils/getOffset';
import type {SearchProps, WorkSearchProps} from '../types';
import workQuery from '../data/workQuery.json';
import {normalizeQuery} from '../functions';

const WORK_INDEX = 'ebs-work-alias';

// Product owners excluded from work search. Hachette (4253) is excluded by
// default and only included when the caller opts in via `includeHachetteWorks`.
const EXCLUDED_OWNERS = ['4252', '4296', '4476'];
const HACHETTE_OWNER = '4253';

export const mapWorkSearchPropsToSearchProps = ({
  query,
  page,
  size,
  includeHachetteWorks,
  abortSignal,
}: WorkSearchProps): SearchProps => {
  const normalizedQuery = normalizeQuery(query);
  const from = getOffset(page, size);

  const excludedOwners = includeHachetteWorks
    ? EXCLUDED_OWNERS
    : [...EXCLUDED_OWNERS, HACHETTE_OWNER];

  // The template carries the full elastic body including `from`/`size`/
  // `highlight`. The `"${FROM_PLACEHOLDER}"` and `"${SIZE_PLACEHOLDER}"`
  // tokens are quoted strings in the JSON; substituting with unquoted
  // numbers turns them into numeric fields once re-parsed.
  const elasticBody = JSON.parse(
    JSON.stringify(workQuery)
      .replaceAll('${QUERY_PLACEHOLDER}', normalizedQuery)
      .replaceAll('"${FROM_PLACEHOLDER}"', String(from))
      .replaceAll('"${SIZE_PLACEHOLDER}"', String(size))
      .replaceAll(
        '"${EXCLUDED_PRODUCTOWNERS_PLACEHOLDER}"',
        JSON.stringify(excludedOwners),
      ),
  ) as JSONValue;

  return {
    target: '_search',
    index: WORK_INDEX,
    elasticBody,
    abortSignal,
  };
};
